export const environment = {
  portalUrl: 'https://portal.dev.skybeans.app/',
  androidUrl: 'https://play.google.com/store/apps/details?id=skyowl.skybeans.app&hl=en_US',
  iOSUrl: 'https://apps.apple.com/us/app/skybeans/id6737355311',
  isProduction: false
};
